import $ from 'jquery';

function ShowablePassword() {
  this.$el = $('.js-showable-password');
  this.$controller = $('.js-showable-password-trigger');
  this.$passwordField = $('.js-password');

  this.$controller.on('click', this.toggleShowPassword.bind(this));
}

ShowablePassword.prototype.toggleShowPassword = function (e) {
  e.preventDefault();

  var otherText = this.$controller.data('other-state-text');
  this.$controller.data('other-state-text', this.$controller.html());
  this.$controller.html(otherText);

  if (this.$el.hasClass('is-showing-password')) {
    this.$el.removeClass('is-showing-password')
    this.$passwordField.attr('type', 'password');
  } else {
    this.$el.addClass('is-showing-password')
    this.$passwordField.attr('type', 'text');
  }
}

export default ShowablePassword;
